import { getStaticAssetPath } from './pathUtils';

export const getDefaultAvatarPath = () => {
  return getStaticAssetPath('/images/avatar.png');
};

export const fetchUserAvatar = async (ensOrAddress: string) => {
  try {
    const response = await fetch(`https://api.ethfollow.xyz/api/v1/users/${ensOrAddress}/account`);
    const data = await response.json();
    return data.ens?.avatar || getDefaultAvatarPath();
  } catch (error) {
    console.error('Error fetching avatar:', error);
    return getDefaultAvatarPath();
  }
}; 